<template>
  <div class="evaluate-list" ref="container">
    <nav-bar
      fixed
      z-index="99"
      title="我的评价"
      left-text="返回"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <div style="height: 46px"></div>

    <div style="height: 10px"></div>
    <UserEvaluation :reply="reply"></UserEvaluation>
    <Loading :loaded="loadend" :loading="loading"></Loading>
  </div>
</template>
<script>
import UserEvaluation from "@components/UserEvaluation";
import { getMyCommentList } from "@api/user";
import Loading from "@components/Loading";
import { NavBar } from "vant";
let NAME = "EvaluateList";

export default {
  name: "EvaluateList",
  components: {
    UserEvaluation,
    Loading,
    NavBar,
  },
  props: {},
  data: function () {
    return {
      currentActive: 0,
      page: 1,
      limit: 8,
      reply: [],
      loadTitle: "",
      loading: false,
      loadend: false,
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME) {
        this.loadend = false;
        this.page = 1;
        this.$set(this, "reply", []);
        this.getProductReplyList();
      }
    },
  },
  mounted: function () {
    this.getProductReplyList();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getProductReplyList();
    });
  },
  methods: {
    getProductReplyList: function () {
      let that = this;
      if (that.loading) return;
      if (that.loadend) return;
      that.loading = true;
      let q = { page: that.page, limit: that.limit, type: that.currentActive };
      getMyCommentList(q).then((res) => {
        that.loading = false;

        for (let item of res.data) {
          item.picturesArr = item.pics ? item.pics.split(",") : [];
        }

        console.log(res, "res.data.picturesArr");
        that.reply.push.apply(that.reply, res.data);
        that.loadend = res.data.length < that.limit; //判断所有数据是否加载完成；
        that.page = that.page + 1;
      });
    },
    changeType: function (index) {
      let that = this;
      that.currentActive = index;
      that.page = 1;
      that.loadend = false;
      that.$set(that, "reply", []);
      that.getProductReplyList();
    },
  },
};
</script>
<style scoped>
.noCommodity {
  height: 8rem;
  background-color: #fff;
}
</style>
